/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Button from 'flarum/common/components/Button';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import app from 'flarum/forum/app';
import { slug } from '../../../../common';
import AbstractInput from './AbstractInput';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.inputs.labels`;

export default class Select extends AbstractInput {
	get defaultValue() {
		return undefined;
	}

	className() {
		return `${super.className()} ${super.className()}--select`;
	}

	content() {
		const { name, options } = this.attrs;

		return [
			<label className="label">{t(`${prfx}.${name}`)}</label>,
			<SelectDropdown buttonClassName="Button Button--secondary" caretIcon="far fa-chevron-down" defaultLabel={t(`${prfx}.option_none`)}>
				{options.map((option) => (
					<Button active={this.value() === option} icon={this.value() === option ? 'far fa-check' : true} onclick={() => this.value(option)}>
						{t(`${prfx}.${name}_options.${option}`)}
					</Button>
				))}
			</SelectDropdown>,
		];
	}
}
